import "./alert.css";

const AlertDanger = (props) => {
  const { message } = props;

  const splitMessage = () => {
    if (message.length > 0) {
      return (
        <div>
          {message.map((item, index) => {
            return (
              <div key={index}>
                <span className="text-danger">{item}</span>
              </div>
            );
          })}
        </div>
      );
    }
  };

  return <div className="alert alert-danger">{splitMessage()}</div>;
};

const AlertSuccess = (props) => {
  const { message } = props;

  return <div className="alert alert-success">{message}</div>;
};

const AlertInfo = (props) => {
  const { message } = props;

  return <div className="alert alert-info">{message}</div>;
};

const AlertWarning = (props) => {
  const { message } = props;

  return <div className="alert alert-warning">{message}</div>;
};

export { AlertDanger, AlertSuccess, AlertInfo, AlertWarning };
